import { gql } from '@apollo/client';
import { DriverAddressInput } from './assignDrivers';

export interface SubmitRoutePlanningTaskRequestInput {
    warehouseId: number;
    areaId: number;
    driverAccountId: number;
    orderIds: number[];
    startAddress?: DriverAddressInput | null;
    endAddress?: DriverAddressInput | null;
}

export interface SubmitRoutePlanningTaskResponse {
    submitRoutePlanningTask: number; // taskId (Long)
}

export interface SubmitRoutePlanningTaskVariables {
    request: SubmitRoutePlanningTaskRequestInput;
}

export const SUBMIT_ROUTE_PLANNING_TASK = gql`
    mutation SubmitRoutePlanningTask($request: SubmitRoutePlanningTaskRequestInput!) {
        submitRoutePlanningTask(request: $request)
    }
`;
